export interface Details {
  description: string;
  number: number;
  product: string;
  quantity: number;
  quantityIssued: number;
  type: string;
  uom: string | null;
}
